import { ApiResponse, BaseCreateResponse, BaseResponse, baseUrl, deleteWithAuth, EmptyRequest, getWithAuth, Guid, ListRespone, patchWithAuth, postWithAuth } from "./baseApi";

// TV channels
export interface TVChannel {
    id: Guid,
    name: string,
    domain: string,
    notMappedInProfiles: TVProfile[]
}

export interface TVChannelRequest {
    name: string,
    domain: string,
}

export interface TVProfile {
    id: Guid,
    name: string,
    isDefault: boolean
}

export interface TVProfileRequest {
    name: string,
}

export interface TVChannelMapping {
    id: Guid,
    name: string,
    irCommand: string
}

export interface TVChannelMappingCreateRequest {
    tvChannelId: Guid,
    command: string
}

export interface TVChannelMappingUpdateRequest {
    command: string
}

export const getTVChannels = async() : Promise<ApiResponse<ListRespone<TVChannel>>> => {
    return await getWithAuth<ListRespone<TVChannel>>({url : `${baseUrl}tvchannels`});
}

export const createTVChannel = async( request : TVChannelRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await postWithAuth<TVChannelRequest,BaseCreateResponse>(`${baseUrl}tvchannels`, request);
}

export const updateTVChannel = async(id : Guid, request : TVChannelRequest) : Promise<ApiResponse<BaseResponse>> => {
    return await patchWithAuth<TVChannelRequest,BaseResponse>(`${baseUrl}tvchannels/${id}`, request);
}

export const deleteTVChannel = async (id : Guid) : Promise<ApiResponse<BaseResponse>> =>{
    return await deleteWithAuth<BaseResponse>(`${baseUrl}tvchannels`, id)
}

//TV Profiles
export const getTVProfiles = async() : Promise<ApiResponse<ListRespone<TVProfile>>> => {
    return await getWithAuth<ListRespone<TVProfile>>({url : `${baseUrl}tvchannels/profiles`});
}

export const createTVProfile = async( request : TVProfileRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await postWithAuth<TVProfileRequest,BaseCreateResponse>(`${baseUrl}tvchannels/profiles`, request);
}

export const updateTVProfile = async(id : Guid, request : TVProfileRequest) : Promise<ApiResponse<BaseResponse>> => {
    return await patchWithAuth<TVProfileRequest,BaseResponse>(`${baseUrl}tvchannels/profiles/${id}`, request);
}

export const deleteTVProfile = async (id : Guid) : Promise<ApiResponse<BaseResponse>> =>{
    return await deleteWithAuth<BaseResponse>(`${baseUrl}tvchannels/profiles`, id)
}

export const cloneTVProfile = async (id: Guid,) : Promise<ApiResponse<BaseResponse>> => {
    return await postWithAuth<EmptyRequest, BaseResponse>(`${baseUrl}tvchannels/profiles/${id}/clone`, {}); 
}

//TV Channels Mapping
export const getTVChannelMappings = async(id: Guid) : Promise<ApiResponse<ListRespone<TVChannelMapping>>> => {
    return await getWithAuth<ListRespone<TVChannelMapping>>({url : `${baseUrl}tvchannels/profiles/${id}/mappings`});
}

export const createTVChannelMapping = async(id:Guid, request : TVChannelMappingCreateRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await postWithAuth<TVChannelMappingCreateRequest,BaseCreateResponse>(`${baseUrl}tvchannels/profiles/${id}/mappings`, request);
}

export const updateTVChannelMapping = async(profileId:Guid, id : Guid, request : TVChannelMappingUpdateRequest) : Promise<ApiResponse<BaseResponse>> => {
    return await patchWithAuth<TVChannelMappingUpdateRequest,BaseResponse>(`${baseUrl}tvchannels/profiles/${profileId}/mappings/${id}`, request);
}

export const deleteTVChannelMapping = async (profileId: Guid, id : Guid ) : Promise<ApiResponse<BaseResponse>> =>{
    return await deleteWithAuth<BaseResponse>(`${baseUrl}tvchannels/profiles/${profileId}/mappings`, id)
}